const privacySettings = {
  'privacy.leaderboard.section.title': 'Leaderboard Settings',
  'privacy.leaderboard.opt-in': 'Join leaderboards',
  'privacy.leaderboard.opt-in.explanation':
    'Share your best scores with other players and see how you rank against them.',
  'privacy.leaderboard.anonymous': 'Anonymous ranking',
  'privacy.leaderboard.anonymous.explanation': 'Your name and avatar will not be shared with other players.',

  'privacy.profile.section.title': 'Profile Settings',
  'privacy.admin-profile.opt-in': 'Share data with admins',
  'privacy.admin-profile.explanation': 'Share your profile & training data with admins of your private groups.',
  'privacy.admin-profile.note': 'EG: Coaches, Trainers, Parents.',
  'privacy.group-profile.opt-in': 'Share data with groups',
  'privacy.group-profile.explanation': 'Share your profile & training data with players of your private groups.',
  'privacy.public-profile.opt-in': 'Share profile with all players',
  'privacy.public-profile.explanation': 'Make your profile visible to other players outside of your groups.',
  'privacy.public-profile.note': '(Note: This does not share your training data).',

  'privacy.push-notifications.opt-in': 'Push Notifications',
  'privacy.push-notifications.explanation': 'Receive notifications about your training progress and new features.',
  'privacy.push-notifications.note': 'You can change this setting at any time in your profile settings.',
};

export const privacy = {
  ...privacySettings,
};